import React, { Component } from "react";
import "./login.css";
import firebase from "../../firebase";
import { connect } from "react-redux";
import { setLogInDetails, setAdminRecord } from "../../actions/setpersondetailsaction";
import { fetchAdminRecord, storeAdminSession } from "../../utils/adminAuth";

class LoginPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      disableBtn: "",
      email: "",
      password: "",
      invaild: "invaild",
      accessDenied: false,
    };
  }

  login = async (e) => {
    e.preventDefault();
    this.setState({ disableBtn: "disable", invaild: "invaild", accessDenied: false });

    try {
      const userCredential = await firebase
        .auth()
        .signInWithEmailAndPassword(this.state.email, this.state.password);

      const uid = userCredential.user.uid;
      const email = userCredential.user.email;

      // Fetch admin record from adminUsers collection
      const adminRecord = await fetchAdminRecord(uid, email);

      if (!adminRecord) {
        // Authenticated via Firebase but not in adminUsers → deny access
        await firebase.auth().signOut();
        this.setState({ disableBtn: "", accessDenied: true });
        return;
      }

      if (adminRecord.status !== "active") {
        await firebase.auth().signOut();
        this.setState({ disableBtn: "", accessDenied: true });
        return;
      }

      // Persist role/vendorId in localStorage and Redux
      storeAdminSession(adminRecord);
      this.props.setAdminRecord(adminRecord);
      this.props.setOnLogInDetails({ isLoggedIn: true });
    } catch (error) {
      this.setState({ disableBtn: "", invaild: "" });
    }
  };

  onEdit = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  render() {
    return (
      <div className="login_page">
        <div className="login_container">
          <div className="login_card">
            <div className="login_header">
              <div className="login_logo">
                <i className="fa fa-lock"></i>
              </div>
              <h1>Zenith Cult Admin</h1>
              <p>Sign in to your account</p>
            </div>

            <form onSubmit={this.login} className="login_form">
              <div className="form_group">
                <label htmlFor="email">Email Address</label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  placeholder="admin@example.com"
                  onChange={this.onEdit}
                  required
                  className="form_input"
                />
              </div>

              <div className="form_group">
                <label htmlFor="password">Password</label>
                <input
                  id="password"
                  type="password"
                  placeholder="Enter your password"
                  name="password"
                  onChange={this.onEdit}
                  required
                  className="form_input"
                />
              </div>

              <p className={`error_message ${this.state.invaild}`}>
                Invalid email or password
              </p>

              {this.state.accessDenied && (
                <p className="error_message">
                  Access denied. Your account is not authorised for this panel.
                </p>
              )}

              <button
                type="submit"
                className="login_button"
                disabled={this.state.disableBtn}
              >
                {this.state.disableBtn ? (
                  <>
                    <i className="fa fa-spinner fa-spin"></i> Signing In...
                  </>
                ) : (
                  <>
                    <i className="fa fa-unlock"></i> Sign In
                  </>
                )}
              </button>
            </form>

            <div className="login_footer">
              <p>© 2024 Zenith Cult. All rights reserved.</p>
            </div>
          </div>

          <div className="login_background">
            <img alt="Background" src={require("../../Images/doctorbg.jpg")} />
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  setOnLogInDetails: (p) => dispatch(setLogInDetails(p)),
  setAdminRecord: (record) => dispatch(setAdminRecord(record)),
});

export default connect(null, mapDispatchToProps)(LoginPage);

